import * as ko from 'knockout'
import ObservableRaceReplay from '../../../Model/Observables/ObservableRaceReplay'
import { RaceReplayViewModel } from './RaceReplayViewModel'
import raceReplayVideoTemplate from './race-replay-video.tpl.html'
import raceReplayTemplate from './race-replay.tpl.html'

if (!ko.components.isRegistered('race-replay')) {
  ko.components.register('race-replay', {
    viewModel: {
      createViewModel: (params: {
        id: string
        raceReplayData: ObservableRaceReplay
        source: string
      }) => {
        const viewModel = new RaceReplayViewModel(params)
        return viewModel
      },
    },
    template: raceReplayTemplate,
  })
}

if (!ko.components.isRegistered('race-replay-video')) {
  ko.components.register('race-replay-video', {
    template: raceReplayVideoTemplate,
  })
}
